/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import AccountDetails from '../../components/AccountDetails';
import { useSelector } from 'react-redux';
import Breadcrumbs from '../../components/BreadCrumbs';
import FeatureFlagMessage from '../../components/FeatureFlagMessage';
import Spinner from '../../components/Spinner';

const AccountDetailsPage: React.FC = (prop: any) => {
  const { contentfulData } = useSelector(
    (state: { contentful: any }) => state.contentful
  );

  const { entries, assets } = contentfulData;
  const [showFeatureFlagMessage, setShowFeatureFlagMessage] = useState(false);

  return (
    <>
      {entries?.rb_account_details ? (
        <>
          {showFeatureFlagMessage && (
            <FeatureFlagMessage className="md:left-20 left-0" />
          )}

          <div className="bg-bg-body py-4 px-8">
            <Breadcrumbs
              items={[
                { name: entries?.rb_navigation?.homeLogoTitle, href: '/' },
                {
                  name: entries?.rb_account_details?.accountDetailsTitle,
                  href: '/account-details',
                },
              ]}
            />

            <AccountDetails
              contentfulData={entries?.rb_account_details}
              assets={assets}
              setShowFeatureFlagMessage={setShowFeatureFlagMessage}
              featureFlaggingData={
                entries?.rb_feature_flagging?.featureFlagging?.account_details
                  ?.account_settings
              }
            />
          </div>
        </>
      ) : (
        <div>
          <Spinner />
        </div>
      )}
    </>
  );
};

export default AccountDetailsPage;
